import type { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const DumbbellIcon: React.FC<IconSvgProps> = (props) => (
  <svg
    width={props.size}
    height={props.size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.17915 21.3697L2.52229 15.7128C2.13177 15.3223 2.13177 14.6892 2.52229 14.2986C2.91282 13.9081 3.54598 13.9081 3.93651 14.2986L9.59336 19.9555C9.98388 20.346 9.98388 20.9792 9.59336 21.3697C9.20284 21.7602 8.56967 21.7602 8.17915 21.3697Z"
      fill={props.color}
    />
    <path
      d="M20.9072 8.64179L15.2503 2.98494C14.8598 2.59441 14.8598 1.96125 15.2503 1.57073C15.6408 1.1802 16.274 1.1802 16.6645 1.57073L22.3214 7.22758C22.7119 7.6181 22.7119 8.25127 22.3214 8.64179C21.9309 9.03232 21.2977 9.03232 20.9072 8.64179Z"
      fill={props.color}
    />
    <path
      d="M11.3611 21.0161L2.87581 12.5308C2.48528 12.1403 2.48528 11.5071 2.87581 11.1166C3.26633 10.7261 3.8995 10.7261 4.29002 11.1166L12.7753 19.6019C13.1658 19.9924 13.1658 20.6256 12.7753 21.0161C12.3848 21.4066 11.7516 21.4066 11.3611 21.0161Z"
      fill={props.color}
    />
    <path
      d="M20.5535 11.8237L12.0682 3.33845C11.6777 2.94793 11.6777 2.31477 12.0682 1.92424C12.4587 1.53372 13.0919 1.53372 13.4824 1.92424L21.9677 10.4095C22.3582 10.8 22.3582 11.4332 21.9677 11.8237C21.5772 12.2143 20.944 12.2143 20.5535 11.8237Z"
      fill={props.color}
    />
    <path
      d="M15.9573 6.5205C16.3478 6.12998 16.981 6.12998 17.3715 6.5205C17.762 6.91103 17.762 7.54419 17.3715 7.93472L8.88621 16.42C8.49569 16.8105 7.86252 16.8105 7.472 16.42C7.08148 16.0295 7.08148 15.3963 7.472 15.0058L15.9573 6.5205Z"
      fill={props.color}
    />
  </svg>
)
